import IndicadorAbstractService from "@/business/indicadores/IndicadorAbstractService";
import Http from "@/commons/Http";
import Utils from "@/commons/Utils";
import AnexoBusiness from "@/business/AnexoBusiness";
import VueBusiness from "@/business/VueBusiness";
import FrontBusiness from "@/business/FrontBusiness";

const path = 'api/v2/registro-notas';

export default {

  ...IndicadorAbstractService,

  async save(id, dto) {
    if(!id){
      return Http.post(`${path}`, dto);
    }
    return Http.post(`${path}/${id}`, dto);
  },

  async paginationV2(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/v2/pagination?sort=${sort || 'i.codigo'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  getTipos() {
    let livros =  [
      {id: 'ESCRITURA', nome: 'Escritura'},
      {id: 'PROCURACAO', nome: 'Procuração'},
      {id: 'SUBSTABELECIMENTO', nome: 'Substabelecimento'},
      {id: 'TESTAMENTO', nome: 'Testamento'},
    ];
    if(VueBusiness.getVueRoot().isEstadoGO) {
      livros.push({id: 'ABONO_SINAL_PUBLICO', nome: 'Abono de Sinal Público'});
    }

    if (VueBusiness.getVueRoot().config?.tabelionato?.habilitarAtaNotarial) {
      livros.push({id: 'ATA_NOTARIAL', nome: 'Ata Notarial'});
    }
    return livros;
  },

  getStatusImovel(completa = false) {
    let status = [
      {id: 'LAVRADO', nome: 'Lavrado'},
      {id: 'ADITADO', nome: 'Aditado'},
      {id: 'RENUNCIADO', nome: 'Renunciado'},
      {id: 'RERRATIFICADO', nome: 'Rerratificado'},
      {id: 'RETIFICADO', nome: 'Retificado'},
      {id: 'DISSOLVIDO', nome: 'Dissolvido'},
      {id: 'REVOGADO', nome: 'Revogado'},
      {id: 'DISTRATADO', nome: 'Distratado'},
      {id: 'SEM_EFEITO', nome: 'Sem Efeito'},
      {id: 'INCOMPLETO', nome: 'Incompleto'},
      {id: 'SUBSTABELECIDO', nome: 'Substabelecido'},
      {id: 'REVOGADO_PARCIALMENTE', nome: 'Revogado Parcialmente'},
      {id: 'SUBSTABELECIDO_PARCIALMENTE', nome: 'Substabelecido Parcialmente'},
    ];
    if (completa) {
      status.push({id: 'PENDENTE', nome: 'Pendente'})
    }
    return status
  },

  async getStatusPorDominio(dominio) {
    const mapa = VueBusiness.getVueRoot().enums?.StatusFichaPorLivro;
    return [...(mapa?.[dominio] || [])];
  },

  camposConsulta() {
    return Utils.orderBy([
      {id: 'tipo_registro', nome: 'Tipo Livro', type: 'list', options: this.getTipos()},

      {id: 'envolvido_cpf', status: ['ABERTA','CANCELADA','ENCERRADA'],  nome: 'CPF Envolvido', type: 'cpf'},
      {id: 'envolvido_cnpj', status: ['ABERTA','CANCELADA','ENCERRADA'], nome: 'CNPJ Envolvido', type: 'cnpj'},
      {id: 'envolvido_nome', status: ['ABERTA','CANCELADA','ENCERRADA'], nome: 'Nome Envolvido', type: 'text'},

      {id: 'data_alteracao_manual', status: ['ABERTA','CANCELADA','ENCERRADA'], nome: 'Data da Alteração Manual', type: 'date'},
      {id: 'atualizacao_status', status: ['ABERTA','CANCELADA','ENCERRADA'], nome: 'Data de Alteração de Status', type: 'date'},
      {id: 'registro', status: ['ABERTA','CANCELADA','ENCERRADA'], nome: 'Data de Lavratura', type: 'date'},
      {id: 'digitalizacao', status: ['ABERTA','CANCELADA','ENCERRADA'], nome: 'Digitalização', type: 'list', options: AnexoBusiness.tiposDigitalizacao().slice(1)},
      {id: 'livro_registro', nome: 'Livro - Registro', type: 'text-retro'},
      {id: 'folha_registro', nome: 'Folha - Registro', type: 'text-retro'},
      {id: 'livro_letra', nome: 'Livro (Letra)', type: 'text-retro'},

      {id: 'ato_minuta', status: ['ABERTA','CANCELADA','ENCERRADA'], nome: 'Minuta dos Atos Registrados', type: 'tsquery'},
      {id: 'ato_titulo', status: ['ABERTA','CANCELADA','ENCERRADA'], nome: 'Título dos Atos Registrados', type: 'tsquery'},

      {id: 'observacoes', nome: 'Observações', type: 'tsquery'},

      {id: 'codigo', nome: 'Registro', type: 'number'},
      {id: 'status', status: ['ABERTA','CANCELADA','ENCERRADA'], nome: 'Status', type: 'list', options: this.getStatusImovel()},

    ], 'nome');
  },

  async criarLote(quantidade = 1, dto) {
    const response = await Http.post(`${path}`, dto);
    return Array.isArray(response) ? response : [response];
  },

  formatarNomeStatus(enumName) {
    const lista = VueBusiness.getVueRoot().enums?.EnumStatusFicha;
    return lista?.find(s => s.id === enumName)?.nome || enumName;
  },

  todosEnvolvidosPossuemRepresentantePrincipal(dominio, dto) {
    if (dominio !== 'SERVICO_TN' || !dto.envolvidos?.length) {
      return true;
    }

    const envolvidoSemPrincipal = dto.envolvidos.find(
      envolvido => !envolvido.representantes?.some(
        representante => representante.principal
      )
    );

    if (!envolvidoSemPrincipal) {
      return true;
    }

    if(envolvidoSemPrincipal.tipoPessoa !== 'JURIDICA') {
      return true;
    }

    const nomeEnvolvido = envolvidoSemPrincipal.nome?.trim();

    FrontBusiness.showError(
      nomeEnvolvido
        ? `O envolvido ${nomeEnvolvido} não possui representante principal.`
        : 'Existe um envolvido sem representante principal.'
    );

    return false;
  }
}
